import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";
import { addFAQs, addGlossary, UpdateGlossary } from '../../../stores/services/knowledgebase.service';

function EditGlossary(props) {
    const {
        refreshData,
        setRefreshData,
        setEditModalFlag
    } = props
    const [title, setTitle] = useState<string>("")
    const [des, setDes] = useState<string>("")
    const [letter, setLetter] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [objValue, setObjValue] = useState<any>()
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const borderRadiusStyle = { borderRadius: 2 };
    const [loadingData, setLoadingData] = useState<boolean>(false)


    useEffect(() => {
        setLoadingData(true)
        const obj = JSON.parse(sessionStorage.getItem("GlossaryObj") || "");
        setObjValue(obj)
        setTitle(obj?.title?.trim() || "")
        setDes(obj?.description?.trim() || "")
        setLetter(obj?.letter || "")
        setStatus(obj?.status)
        setLoadingData(false)
    }, [])

    const handleUpdate = async () => {
        if (title == "") {
            toast.error("Title field can not be empty")
            return
        }
        if (des == "") {
            toast.error("Description field can not be empty")
            return
        }
        setLoading(false)
        try {
            let res = await UpdateGlossary(
                email,
                amc_code,
                objValue?._id,
                title || "",
                des || "",
            )
            if (res.status == 200 && res.data.status == 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        } catch (error) {
            toast.error("Error Updating Glossary")
        }
        finally {
            setLoading(false)
            setEditModalFlag(false)
        }
    }

    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                {!loadingData ?
                    <Row>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Title'
                                    value={title}
                                    onChange={(e) => {
                                        setTitle(e.target.value);
                                    }}
                                />
                            </div>
                            {/* {nameError === true ? (
                                  <p className="error-labels">Name is Required.</p>
                                ) : (
                                  ""
                                )} */}
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    rows={3}
                                    className="form-control"
                                    placeholder='Enter Description'
                                    value={des}
                                    onChange={(e) => {
                                        setDes(e.target.value);
                                    }}
                                />
                            </div>
                        </Col>
                        <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Letter</label>
                                <input
                                    className="form-control"
                                    placeholder='Enter Letter'
                                    value={letter}
                                    disabled
                                />
                            </div>
                        </Col>
                        {/* <Col md="12" className='px-0'>
                            <div className="form-group">
                                <label>Status</label>
                                <ToggleButton
                                    inactiveLabel=""
                                    activeLabel=""
                                    value={status}
                                    thumbStyle={borderRadiusStyle}
                                    trackStyle={borderRadiusStyle}
                                    onToggle={() => {
                                        setStatus(!status)
                                    }}
                                />
                            </div>
                        </Col> */}
                    </Row> :
                    <div className="d-flex justify-content-center my-5">
                        <div
                            className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                            role="status"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setEditModalFlag(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleUpdate()}
                        disabled={loading}
                        color='primary'>
                        Update
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default EditGlossary